@if (inputStatus !== undefined) {
  <div [ngClass]="{ 'in-table': inTable }">
    @if (editable) {
      <mat-slide-toggle [formControl]="status" (change)="onChange()"></mat-slide-toggle>
    } @else {
      <mat-slide-toggle [formControl]="status" (click)="$event.preventDefault()"></mat-slide-toggle>
    }
  </div>
}
